import { ResponseDto } from '@diritto/common/base/response.dto';
import { ReplyApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useDeleteReplyMutation = (options?: UseMutationOptions<ResponseDto, unknown, number>) =>
  useMutation({ mutationFn: (id: number) => ReplyApi.deleteReply(id), ...options });
